import classNames from 'classnames';
import {FC} from 'react';

import styles from './Skeleton.module.css';

type Props = {
    borderRadius?: string | number;
    width?: string | number;
    height?: string | number;
    className?: string;
    color?: 'default' | 'secondary';
};

export const Skeleton: FC<Props> = ({
    width,
    height,
    borderRadius,
    className,
    color = 'default',
}) => {
    return (
        <div
            style={{width, height, borderRadius}}
            className={classNames(styles.block, className, {
                [styles.secondaryColor]: color === 'secondary',
            })}
        />
    );
};
